export const CARD_LABELS = {
    CUSTOMIZE: 'Customize',
    DETAILS: 'See Details',
    INCLUDED: 'Included',
    MOST_POPULAR: 'Most Popular',
    FREE_SHIPPING: 'Free Shipping',
    SAVE: value => `Save ${value}`
}